<template>
    <modal v-model="show" :appear="notification.appear">
        <h2 v-if="notification.heading" class="heading-2">{{ notification.heading }}</h2>
        {{ notification.body }}
    </modal>
</template>

<script setup>
import { computed } from 'vue'
import { useNotificationStore } from '@/stores/notification'

const notification = useNotificationStore()

const show = computed({
    get: () => notification.type == 'modal',
    set: () => notification.clear(),
})

</script>
